export interface SortFieldConfig {
  [columnIndex: number]: string;
}

export const ENG_ASSESSMENT_SORT_CONFIG: SortFieldConfig = {
  1: "created_at",
  2: "user",
  3: "overall_score",
  4: "status"
};

export const ANNOTATION_ASSESSMENT_SORT_CONFIG: SortFieldConfig = {
  1: "created_at",
  2: "user",
  3: "overall_score",
  4: "status"
};

export const AI_ASSESSMENT_SORT_CONFIG: SortFieldConfig = {
  1: "created_at",
  2: "user",
  3: "overall_score",
  4: "status"
};

export const AI_ASSESSMENT_QUESTION_TYPE_CONFIG: Record<string, string> = {
  short_answer: "Short question",
  mcq: "Multiple Choice Question",
  true_false: "True False"
};
